import {useEffect, useState} from "react";
import Slider from "../Slider";
import profile_api from "../../api/protected/profile";
import stripe_api from "../../api/protected/memberships";
import {Link, useNavigate} from "react-router-dom";
import TextUtils from "../../utils/TextUtils";
import AccreditationPopup from "../AccreditationPopup";
import bronze_medal from "../../assets/bronze-medal.png"
import silver_medal from "../../assets/silver-medal.png"
import gold_medal from "../../assets/gold-medal.png"
import verified from "../../assets/accreditation-verified.svg"
import awaiting from "../../assets/accreditation-awaiting.svg"

const SettingsPreferences = (props) => {
    const navigate = useNavigate()
    const [subscription, setSubscription] = useState()
    const [accreditation, setAccreditation] = useState()
    const [userRegistrationDate, setUserRegistrationDate] = useState()

    const updateProfile = props.updateProfile;
    const [newsletter, setNewsletter] = useState(false);
    const [diagnostic, setDiagnostic] = useState(false);
    const [coaching, setCoaching] = useState(false);
    const [autofill, setAutofill] = useState(true)

    const [showAccreditationPopup, setShowAccreditationPopup] = useState(false)

    const updateNewsletter = (setting) => {
        setNewsletter(setting);
        let body = {
            "newsletter_consent": setting,
            "diagnostic_consent": diagnostic,
            "coaching_consent": coaching
        }
        updateMarketingConsent(body)
    }

    const updateCoaching = (setting) => {
        setCoaching(setting);
        let body = {
            "newsletter_consent": newsletter,
            "diagnostic_consent": diagnostic,
            "coaching_consent": setting
        }
        updateMarketingConsent(body)
    }

    const updateDiagnostic = (setting) => {
        setDiagnostic(setting);
        let body = {
            "newsletter_consent": newsletter,
            "diagnostic_consent": setting,
            "coaching_consent": coaching
        }
        updateMarketingConsent(body)
    }

    const updateMarketingConsent = (body) => {
        let response = profile_api.updateNewsletter(body);
        response.then(() => {
            updateProfile();
        }).catch(() => {})
    }

    const updateAutofill = (setting) => {
        setAutofill(setting);
        let response = profile_api.updateAutofill({"autofill": setting});
        response.then(() => {
            updateProfile();
        }).catch(() => {})
    }

    useEffect(() => {
        getSubscription()
        GetAccreditation()
    }, [])

    const getSubscription = () => {
        let response = profile_api.getSubscription();
        response.then(response => {
            setSubscription(response.data.subscription)
            setUserRegistrationDate(response.data.user_registered_date)
            console.log(response.data.subscription)
        }).catch(() => {})
    }

    const GetAccreditation = () => {
        let response = profile_api.getAccreditation();
        response.then(response => {
            setAccreditation(response.data.accreditation);
        }).catch(err => {console.log(err)})
    }

    const createPortalSession = () => {
        stripe_api.CreatePortalSession();
    }

    useEffect(() => {
        if (!props.profile) return;
        setNewsletter(props.profile.marketing_consent);
        setDiagnostic(props.profile.diagnostic_consent);
        setCoaching(props.profile.coaching_consent);
        setAutofill(props.profile.autofill_enabled)
    }, [props.profile]);

    const handleManageClick = (ev) => {
        if(!ev) return;
        if(subscription && subscription.type) {
            createPortalSession()
        } else {
        navigate('/pricing-plans', {replace: true})
        }
    }

    return (
        <div className="settings-form-container">
            {showAccreditationPopup && showAccreditationPopup ? <AccreditationPopup setShowPopup={setShowAccreditationPopup} /> : null}
            <div className="settings-form-title">Preferences</div>
            <div
                className={`settings-current-plan-container ${subscription && subscription.name ? subscription.name : ""}`}>
                <div className="settings-current-plan-header">
                    <div className="settings-current-plan-header-text">Your current plan</div>
                    <div className="settings-current-plan-header-plan-container">
                        <div>{subscription && subscription.name.toUpperCase()}</div>
                        <img src={subscription && subscription.type === 2 ?
                            gold_medal : subscription && subscription.type === 1 ?
                                silver_medal : bronze_medal
                        } alt="Your current plan"/>
                    </div>
                </div>
                <div className="settings-current-plan-body">
                    <div className="settings-current-plan-body-left">
                        <div className="settings-current-plan-body-left-header">Membership and billing details</div>
                        <div className="settings-current-plan-body-left-membership-container">
                            <div className="membership-text medium">Membership:</div>
                            <div className="membership-value bold">
                                {subscription && subscription.name.toUpperCase()}
                            </div>
                        </div>
                        {/* Start Date (subscription start OR fallback to registration date) */}
                        <div className="settings-current-plan-body-registration-date">
                            <div className="membership-text medium">Subscription Start Date:</div>
                            <div className="membership-value bold">
                                {subscription?.start_date
                                    ? new Date(subscription.start_date * 1000).toLocaleDateString()
                                    : new Date(userRegistrationDate * 1000).toLocaleDateString()
                                }
                            </div>
                        </div>
                        {/* Only show expiry + trial text if subscription exists */}
                        {subscription && (
                            <>
                                {subscription.end_date && (
                                    <>
                                        <div className="settings-current-plan-body-expiry-date">
                                            <div className="membership-text medium">Renews/Expires* on:</div>
                                            <div className="membership-value bold">
                                                {new Date(subscription.end_date * 1000).toLocaleDateString()}
                                            </div>
                                        </div>
                                        <div className="settings-current-plan-body-free-trial-text medium">
                                            *Accounts with Free Trial will move to the basic Bronze Plan and its
                                            associated limitations if a new subscription is not purchased. See FAQ’s
                                            for more details.
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                    <div className="manage-subscription-button bold" onClick={handleManageClick}>
                        MANAGE SUBSCRIPTION
                    </div>
                </div>
            </div>
            <div className="settings-page-subheading">Accreditation</div>
            <div className="settings-page-text">
                {accreditation && accreditation ?
                    <div className="settings-page-accreditation-pending">
                        <div className="accreditation-pending-heading">
                            Type: <span className="regular">{accreditation.type}</span>
                        </div>
                        <div className="accreditation-pending-heading-container">
                            <div className="accreditation-pending-heading">
                                Verification Status:
                            </div>
                            {accreditation.verified && accreditation.verification_date ?
                                <div className="accreditation-result verified bold">
                                    <img src={verified} alt="Verified"/>
                                    Verified
                                </div>
                                : !accreditation.verification_date ?
                                    <div className="accreditation-result awaiting bold">
                                        <img src={awaiting} alt="Awaiting Verification"/>
                                        Awaiting Verification
                                    </div>
                                    :
                                    <div className="accreditation-result denied bold">Denied</div>
                            }
                        </div>
                    </div>
                    :
                    <>
                        You can upload proof of accreditation at any time. Approval of accreditation will be within
                        7 working days. You will not be able to access the full features of the (Gold/Silver) plan
                        until you have uploaded these documents and they have been verified, even if your
                        payment has been taken.
                        <div className="begin-accreditation-button">
                            <div className="field-input-entry">
                                <div className="manage-subscription-button bold"
                                     onClick={() => setShowAccreditationPopup(true)}>
                                    BEGIN ACCREDITATION
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            <div className="settings-page-subheading">Marketing Consent</div>
            <div className="settings-page-text">
                CCMI respects your data and privacy. You can unsubscribe at any time.
                See our <Link to="/privacy" className="settings-link undecorated">Privacy Policy</Link> for more
                details.
            </div>
            <div className="subscribe-slider">
                <Slider update={updateNewsletter.bind(this)} state={newsletter}
                        text="I consent to receiving CCMI Newsletters via email."
                />
            </div>
            <div className="subscribe-slider">
                <Slider update={updateDiagnostic.bind(this)} state={diagnostic}
                        text="I consent to receiving CCMI’s PERILL Diagnostic platform updates, promotional offers and
                        commercial opportunities via email."
                />
            </div>
            <div className="subscribe-slider">
                <Slider update={updateCoaching.bind(this)} state={coaching}
                        text="I consent to receiving information about courses and promotional offers from CCMI and
                        carefully selected partners about Team Coaching via email."
                />
            </div>
            <div className="settings-page-subheading">Autofilled Tasks</div>
            <div className="settings-page-text">
                Enable/Disable automatic tasks in your dashboard to-do list.
            </div>
            <div className="subscribe-slider">
                <Slider update={updateAutofill.bind(this)} state={autofill}
                        text={autofill ? "Disable" : "Enable"}
                />
            </div>
        </div>
    )
}

export default SettingsPreferences